// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__TTYAt","footer":"Sidebar_footer__J9-iw","copyright":"Sidebar_copyright__HNiPV"};